import logger from './logger';

const handleResponse = async (response, logId, startTime) => {
  const duration = Date.now() - startTime;
  const data = await response.json().catch(() => ({ error: 'Failed to parse JSON response' }));

  if (!response.ok) {
    const errorMessage = data.message || data.error || `HTTP error! status: ${response.status}`;
    logger.logError(logId, new Error(errorMessage), response.status);
    throw new Error(errorMessage);
  }
  
  logger.logResponse(logId, response.status, data, duration);
  return data;
};

const setupInstructionsClient = {
  request: async (path, body = {}) => {
    const url = `/api/setup-instructions${path}`;
    const logId = logger.logRequest('setup-instructions', 'POST', url, body);
    const startTime = Date.now();

    try {
      const response = await fetch(url.toString(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });
      return await handleResponse(response, logId, startTime);
    } catch (error) {
      const duration = Date.now() - startTime;
      logger.logError(logId, error, 'NETWORK_ERROR');
      throw error;
    }
  },

  getInstructions: (platform) => setupInstructionsClient.request('/list', { platform }),
  createInstruction: (data) => setupInstructionsClient.request('/create', data),
  updateInstruction: (id, data) => setupInstructionsClient.request('/update', { id, data }),
  deleteInstruction: (id) => setupInstructionsClient.request('/delete', { id }),
};

export default setupInstructionsClient;